
// 引入i18n国际化插件
import { createI18n } from 'vue-i18n'
import ZH from './zh.js';
import EN from './en.js';
const messages = {
  zh: { ...ZH.person },
  en: { ...EN.person },
};

// 注册i18n实例并引入语言文件，文件格式等下解析
const i18n = createI18n({
  locale: 'zh', // 语言环境
  fallbackLocale: 'zh', // 预设语言环境
  silentTranslationWarn: true, // 禁止本地化失败警告
  fallbackRoot: false,
  globalInjection: true,
  legacy: false,
  messages,
  silentTranslationWarn: true,
  missingWarn: false,
  silentFallbackWarn: true,
  fallbackWarn: false
})
export default i18n

